import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';
import { CostCenterUserComponent } from '../../cost-center-user/cost-center-user.component';
import { PermissionsUserComponent } from '../permissions-user/permissions-user.component';
import { UpdatePasswordUserComponent } from '../update-password-user/update-password-user.component';
import { UserModel } from './../../../../models/authentication/user.model';
import { UserService } from './../../../../services/authentication/user.service';

@Component({
  selector: 'app-register-users',
  templateUrl: './register-users.component.html',
  styleUrls: ['./register-users.component.scss'],
  standalone: false
})
export class RegisterUsersComponent implements OnInit, OnDestroy {
  @ViewChild('updatePassword') updatePasswordModalComponent?: CustomModalComponent | null = null;
  @ViewChild('optionWindowUser') optionWindowUserModalComponent?: CustomModalComponent | null = null;
  @ViewChild('costCenterUserModal') costCenterUserModalComponent?: CustomModalComponent | null = null;

  branchesUser: any[] = [];
  componentUpdatePassword = UpdatePasswordUserComponent;
  componentOptionWindowUser = PermissionsUserComponent;
  componentCostCenterUserModal = CostCenterUserComponent;
  disabledActions: boolean = true;
  disabledAccessCostCenter: boolean = true;
  formUser: FormGroup = new FormGroup({});
  formBranch: FormGroup = new FormGroup({});
  disabledForm: boolean = false;
  iconState: string = "pi pi-sync";
  inputsForUpdatePassword$ = new BehaviorSubject<any>({
    userModel: new UserModel,
  });
  inputsForOptionWindowUser$ = new BehaviorSubject<any>({
    userModel: new UserModel,
  });
  inputsForCostCenterUserModals$ = new BehaviorSubject<any>({
    userModel: new UserModel,
  });
  listBranches: any[] = [];
  listProfiles: any[] = [];
  nameWindow: string = 'Captura Usuarios';
  projectName = ProjectName.projectName;
  permissionsUser: OptionWindowModel[] = [];
  severityState: string = "success";
  stateText: string = 'Activo';
  subscription: Subscription;
  subscriptionGeneralParameter?: Subscription;
  swAppMovil: boolean = false;
  titleState: string = "";
  url: string = "user";

  userContract: UserModel = new UserModel();
  userId: number = 0;
  permissionUpdatable: boolean = false;
  userAuthenticated: UserModel = new UserModel();
  isUserCreate: boolean = false;
  isOpened: string | undefined = undefined;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private userService: UserService,
    private windowService: WindowService
  ) { }

  async ngOnInit() {
    await this.validateForm(new UserModel());

    await this.getPermission();
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    this.activatedRoute.params.subscribe(params => {
      this.userId = Object.keys(params).length > 0 ? params?.id : null;
    });

    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
    this.subscriptionGeneralParameter?.unsubscribe();
  }

  addBranch() {
    const branchId = this.formUser.get("branch.branchId")?.value;
    const branch = this.branchesUser.find(x => x.branchId == branchId);
    if (!branch && branchId != 0) {
      const listBranch = this.listBranches.filter(x => x.value == branchId);
      this.branchesUser.push(listBranch[0]);
      this.formBranch.reset();
    }
  }

  async changeState() {
    if (!this.validations()) return;
    try {
      this.userContract = await firstValueFrom(this.userService.setActiveUser(this.userContract.userId));
      await this.validateForm(this.userContract);
      this.toastHandlerService.showToast(
        'success',
        'El estado del usuario se modificó exitosamente.'
      );
    } catch (error) {
      console.error('Error al cambiar el estado del usuario.', error);
    }
  }

  async changeUser() {
    let userName = this.formUser.get("userName")?.value;
    userName = userName === "" ? null : userName;
    if (this.userContract.userName == userName) return;
    if (userName == null) {
      this.resetUser();
      return;
    }

    try {
      this.userContract = await firstValueFrom(this.userService.getUserByUserName(userName));
      this.userId = this.userContract.userId;
      this.branchesUser = this.listBranches.filter(x => this.userContract.branches.includes(x.value));
    } catch (error) {
      console.error('Error al buscar el usuario.', error);
    }
    await this.validateForm(this.userContract);
  }

  async createNewUser() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para crear usuarios. Comuníquese con el administrador del sistema.',
      );
      return;
    }

    await this.resetUser();
  }

  deleteBranch(branchId: number) {
    const index = this.branchesUser.findIndex(x => x.branchId = branchId);
    this.branchesUser.splice(index, 1);
  }

  async deleteUser() {
    if (!this.validations()) return;

    if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar el usuario ${this.userContract.firstName} ${this.userContract.lastName}?`)) {
      try {
        await firstValueFrom(this.userService.deleteUser(this.userContract.userId));
        this.toastHandlerService.showToast(
          'success',
          'El usuario fue eliminado exitosamente.'
        );
        this.createNewUser();
      } catch (error) {
        console.error('Error al eliminar el usuario.', error);
      }
    }
  }

  async getAllLists() {
    try {
      const [branches, profiles] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.userService.getAllProfilesForSelect()),
      ]);
      this.listBranches = branches;
      this.listProfiles = profiles;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  getGeneralParameters() {
    this.subscriptionGeneralParameter = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swAppMovil = response.some(x => x.generalParameterId === GeneralParameterEnums.appMovil);
    });
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      await this.getAllLists();
      this.getGeneralParameters();

    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.User));
  }

  async getUserById() {
    try {
      this.userContract = await firstValueFrom(this.userService.getUserById(this.userId));
      this.userId = this.userContract.userId;
      await this.validateForm(this.userContract);
      this.branchesUser = this.listBranches.filter(x => this.userContract.branches.includes(x.value));
    } catch (error) {
      console.error('Error al buscar el usuario.', error);
    }
  }

  async handleInitialState() {
    if (this.userId !== null && this.userId !== 0) {
      await this.getUserById();
    } else {
      this.createNewUser();
    }
  }

  openCostCenterUserModal() {
    this.inputsForCostCenterUserModals$.next({
      userModel: this.userContract,
    });

    this.costCenterUserModalComponent && this.costCenterUserModalComponent.show();
  }

  openUpdatePasswordModal() {
    this.inputsForUpdatePassword$.next({
      userModel: this.userContract,
    });

    this.updatePasswordModalComponent && this.updatePasswordModalComponent.show();
  }

  openOptionWindowUser() {
    this.inputsForOptionWindowUser$.next({
      userModel: this.userContract,
    });

    this.optionWindowUserModalComponent && this.optionWindowUserModalComponent.show();
  }

  async resetUser() {
    this.userId = 0;
    this.userContract = new UserModel();
    this.branchesUser = [];
    await this.validateForm(this.userContract);
    this.location.replaceState(`/${this.url}/register`);
  }


  async send(): Promise<any> {
    Object.keys(this.formUser.controls).forEach(key => {
      const control = this.formUser.get(key);
      if (control && control.invalid) {
        console.warn(`${key} NO es válido`, control.errors, 'value:', control.value);
      }
    });

    if (this.formUser.valid) {
      const modelUser = this.formUser.getRawValue();
      if (!this.validatePrincipalBranch(modelUser.principalBranchId)) {
        return;
      }

      //Hago null, los campos que permiten ser nulos:
      modelUser.email = modelUser.email || null;

      if (this.userId == 0) {
        modelUser.branches = this.branchesUser.map(x => x.value);
        try {
          const response = await firstValueFrom(this.userService.createUser(modelUser));
          this.toastHandlerService.showToast(
            'success',
            `El usuario fue creado exitosamente.`
          );
          this.userContract = response;
          this.userId = this.userContract.userId;
          await this.validateForm(this.userContract);
          this.location.replaceState(`/${this.url}/register/${this.userId}`);
        } catch (error) {
          console.error('Error al crear el usuario.', error);
        }
      } else {
        this.userContract.firstName = modelUser.firstName;
        this.userContract.lastName = modelUser.lastName;
        this.userContract.profileUserId = modelUser.profileUserId;
        this.userContract.principalBranchId = modelUser.principalBranchId;
        this.userContract.email = modelUser.email;
        this.userContract.rateDiscountMax = modelUser.rateDiscountMax;
        this.userContract.accessAllCostCenters = modelUser.accessAllCostCenters;
        this.userContract.accessApp = modelUser.accessApp;
        this.userContract.accesWeb = modelUser.accesWeb;
        this.userContract.viewAllOrders = modelUser.viewAllOrders;
        this.userContract.branches = this.branchesUser.map(x => x.value);
        try {
          const response = await firstValueFrom(this.userService.updateUser(this.userContract));
          this.toastHandlerService.showToast(
            'success',
            `El usuario fue modificado exitosamente.`
          );
          this.userContract = response;
          await this.validateForm(this.userContract);
        } catch (error) {
          console.error('Error al actualizar el usuario.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      userName: {
        required: 'El campo usuario es obligatorio.',
      },
      firstName: {
        required: 'El campo nombres es obligatorio.',
        maxlength: 'El campo nombres permite máximo 150 caracteres.'

      },
      lastName: {
        required: 'El campo apellidos es obligatorio.',
        maxlength: 'El campo apellidos permite máximo 150 caracteres.'
      },
      profileUserId: {
        required: 'El campo perfil es obligatorio.',
        min: 'El campo perfil es obligatorio.',
      },
      principalBranchId: {
        required: 'El campo sucursal principal obligatorio.',
        min: 'El campo sucursal principal obligatorio.'
      },
      email: {
        maxlength: 'El campo correo permite máximo 256 caracteres.',
        email: 'El correo ingresado no es valido'
      },
      rateDiscountMax: {
        required: 'El campo tarifa descuento es obligatorio.',
        min: 'El campo tarifa descuento permite mínimo 0.',
        max: 'El campo tarifa descuento permite máximo 100.'
      },
      passwordHash: {
        required: 'La contraseña es obligatoria.',
        minlength: 'La contraseña debe tener mínimo 8 caracteres.',
        hasNumber: 'La contraseña debe incluir al menos un número.',
        hasCapitalCase: 'La contraseña debe incluir al menos una letra mayúscula.',
        hasSmallCase: 'La contraseña debe incluir al menos una letra minúscula.',
        hasSpecialCharacters: 'La contraseña debe incluir al menos un carácter especial.',
      },
      confirmPasswordHash: {
        required: 'La confirmación de contraseña es obligatoria.',
        NoPassswordMatch: 'Las contraseñas no coinciden.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formUser.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  async updateFormState() {
    type StateConfig = {
      severity: string;
      icon: string;
      title: string;
      text: string;
      isDisabled: boolean;
    };

    let config: StateConfig;
    if (this.userContract.active) {
      config = {
        severity: 'success',
        icon: 'pi pi-sync',
        title: 'Inactivar',
        text: 'Activo',
        isDisabled: false,
      };
    } else {
      config = {
        severity: 'danger',
        icon: 'pi pi-sync',
        title: 'Activar',
        text: 'Inactivo',
        isDisabled: true,
      };
    }

    if (config) {
      this.severityState = config.severity;
      this.iconState = config.icon;
      this.titleState = config.title;
      this.stateText = config.text;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledForm ? this.formUser.disable() : this.formUser.enable();
    }

    if (!this.disabledForm) this.disabledAccessCostCenter = this.userContract.accessAllCostCenters;
    if (!this.permissionUpdatable) setTimeout(() => this.formUser.disable());
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para modificar el usuario. Comuníquese con el administrador del sistema',
      );
      return false;
    }

    if (this.userContract.userId == 0) {
      this.toastHandlerService.showToast(
        'warning', 'Debe crear un usuario.'
      );
      return false;
    }
    return true;
  }

  validateForm(user: UserModel) {
    this.isUserCreate = user.userId === 0;
    this.formUser = this.formBuilder.group(
      {
        userName: [user.userName, [Validators.required, Validators.maxLength(256)]],
        firstName: [user.firstName, [Validators.required, Validators.maxLength(150)]],
        lastName: [user.lastName, [Validators.required, Validators.maxLength(150)]],
        profileUserId: [user.profileUserId, [Validators.required, Validators.min(1)]],
        principalBranchId: [user.principalBranchId, [Validators.required, Validators.min(1)]],
        email: [user.email, [Validators.email, Validators.maxLength(256)]],
        active: [user.active],
        rateDiscountMax: [user.rateDiscountMax, [Validators.required, Validators.min(0), Validators.max(100)]],
        accessAllCostCenters: [user.accessAllCostCenters],
        accessApp: [user.accessApp],
        accesWeb: [user.accesWeb],
        viewAllOrders: [user.viewAllOrders],
        passwordHash: [null],
        confirmPasswordHash: [null],
        branch: this.formBuilder.group({
          branchId: [null, []]
        })
      },
      {
        // comprobar si su contraseña y confirmar contraseña coinciden
        validator: CustomValidators.passwordMatchValidator
      }
    );
    this.validateRequiredPasswords();
    this.updateFormState();
  }

  validatePrincipalBranch(principalBranchId: any[]): boolean {
    if (this.branchesUser.length == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe seleccionar al menos una sucursal para asignar al usuario.'
      )
      return false;
    }

    const branch = this.branchesUser.find(x => x.value == principalBranchId);
    if (!branch) {
      this.toastHandlerService.showToast(
        'warning',
        'La sucursal principal no forma parte de las sucursales asignadas a su usuario.'
      )
      return false;
    }
    return true;
  }

  validateRequiredPasswords() {
    const passwordHash = this.formUser.get('passwordHash');
    const confirmPasswordHash = this.formUser.get('confirmPasswordHash');
    if (this.userId === 0) {
      passwordHash?.setValidators([Validators.required]);
      passwordHash?.setValidators(Validators.compose([
        // verificar número
        CustomValidators.patternValidator(/\d/, {
          hasNumber: true
        }),
        // verificar letras mayúsculas
        CustomValidators.patternValidator(/[A-Z]/, {
          hasCapitalCase: true
        }),
        // verificar letras minúscula
        CustomValidators.patternValidator(/[a-z]/, {
          hasSmallCase: true
        }),
        // verificar carácter especial
        CustomValidators.patternValidator(
          /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/,
          {
            hasSpecialCharacters: true
          }
        ),
        Validators.minLength(8)
      ]));
      confirmPasswordHash?.setValidators([Validators.required]);
      passwordHash?.updateValueAndValidity();
      confirmPasswordHash?.updateValueAndValidity();
    }

  }
}
